import axios from 'axios'
import qs from 'qs'

export const cgmApi = {
  fetchCgmRecord: function (data) {
    data = qs.stringify(data)
    return axios.post(`/user/query_agp`, data, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
  },
  fetchAidexRecord: function (data) {
    data = qs.stringify(data)
    return axios.post(`/user/query_aidex_agp`, data, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    })
  }
}

export const bgApi = {
  getBgReport: function (data) {
    // data = qs.stringify(data)
    if (data.lang === 'polish') {
      data.lang = 'pl'
    }
    return axios.post(`/web/patient-data/getBgAndPumpReport`, data, {
      headers: {
        [data.lang ? 'Accept-Language' : '']: data.lang
      }
    })

    // // get 请求
    // data = qs.stringify(data)
    // return axios.get(`/web/patient-data/getBgAndPumpReport?${data}`, {
    //   // headers: {
    //   //   'Content-Type': 'application/x-www-form-urlencoded'
    //   // }
    // })
  }
}

export const pumpApi = {
  getPumpReport: bgApi.getBgReport
}
